import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { HEADER } from 'utils/sectionTypes';
import { compose } from 'utils/react';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const defaultProps = {};

const Breadcrumbs = ({
  children,
}) => {
  const [breadcrumbs] = React.Children.toArray(children);
  if (breadcrumbs) {
    return (
      <Container>
        {breadcrumbs}
      </Container>
    );
  }
  return null;
};

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

const component = compose(
  section(
    { name: 'Breadcrumbs', category: 'Breadcrumbs', region: HEADER },
    {
      subsections: [
        { accepts: ['Breadcrumbs'] },
      ],
      defaults: [
        'Breadcrumbs',
      ],
      hideLabel: true,
      menu: true,
    },
  ),
)(Breadcrumbs);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
